module.exports = __webpack_public_path__ + "img/body.237563a8.svg";